export default "__VITE_ASSET__Bw25e8ya__"